/* RayoCommerce OS — fuerza los colores de MARCA RayoTienda en el form COD de Releasit,
   que la app pinta con estilos INLINE !important (el CSS externo no puede ganarle) y
   ADEMAS re-pinta sus botones despues de abrir el modal (animacion "shaker").
   Marca (BrandKit/paleta y tipografia.txt): CTA amarillo #FFC107 + texto navy #0A2540,
   acentos azul electrico #1565C0. Global para todos los productos.
   v4 (2026-07-07): v3 + pintado EXPLICITO por clase de los badges de Quantity Offers (._rsi-quantity-offers-plaque) — asi el look de marca sobrevive a cualquier cambio de color en el panel de Releasit. Estrategia "cazador idempotente" — cada pasada re-pinta SOLO lo que
   este rojo/rosado en ese momento (rojo→CTA amarillo/navy, rosado→lavado frio, borde
   rojo→azul). Como al pintar desaparece el rojo, el proceso se auto-detiene: sin bucles
   aunque el observer dispare por nuestras propias escrituras, y si Releasit sobreescribe
   despues, la siguiente pasada lo vuelve a corregir.
   v5 (2026-07-09): promovido de scope PrintyCat (rc-pc-hero.liquid) a GLOBAL en
   layout/theme.liquid — cubre TODA landing (SafeFry, Canastas, PrintyCat, futuras), no solo
   la que lo incluia manualmente. Suma: cabecera del modal ("CONFIRMACION DEL PEDIDO") y
   titulo de metodo de envio forzados a navy (antes negro puro por config del panel).
   v6 (2026-07-09): el boton secundario "PAGA ANTICIPADO..." se EXCLUYE del pintado amarillo —
   su color (navy) se gobierna desde el panel de Releasit; el amarillo queda reservado al CTA
   COD principal para mantener una sola jerarquia de accion. Deteccion por texto (ANTICIPADO).
   Receta: knowledge/playbooks/crear-landing/colores-de-marca-en-landings.md.
   Alternativa oficial: cambiar los colores en el dashboard de Releasit (Form → colores). */
(function () {
  var CTA = '#FFC107';        /* amarillo rayo */
  var CTA_RGB = 'rgb(255, 193, 7)';
  var CTA_INK = '#0A2540';    /* navy — texto sobre amarillo */
  var WASH = '#F2F6FB';       /* lavado frio para cajas resaltadas */
  var BLUE = '#1565C0';       /* borde de caja seleccionada */
  var NAVY = '#0A2540';
  var BTN_SEL = '#_rsi-buy-now-button, ._rsi-buy-now-button, #_rsi-buy-now-button-floating, ._rsi-buy-now-button-floating, ._rsi-modal-submit-button';
  var PLAQUE_SEL = '._rsi-quantity-offers-plaque';
  var SCOPE_SEL = '[id^="_rsi"], [class*="_rsi"], [class*="releasit"], [id*="releasit"]';
  var HEADER_TITLE_SEL = '._rsi-modal-header-title';
  var SHIPPING_TITLE_SEL = '._rsi-modal-shipping-rates-title';

  function parseRGB(str) {
    var m = /rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)/.exec(str || '');
    return m ? [+m[1], +m[2], +m[3]] : null;
  }
  function isRed(c)  { return !!c && c[0] > 180 && c[1] < 110 && c[2] < 130; }   /* rojos/rosas saturados (#ee2b47, rose-500…) */
  function isPink(c) { return !!c && c[0] > 235 && c[1] > 190 && c[1] < 240 && c[2] > 195 && c[2] < 244 && (c[0] - c[2]) > 4; } /* lavados rosados */
  function isPrepay(el) { return /ANTICIPADO/i.test(el.textContent || ''); }     /* boton secundario de pago anticipado: color del panel, no amarillo */

  function brandButton(el) {
    el.style.setProperty('background', CTA, 'important');
    el.style.setProperty('background-color', CTA, 'important');
    el.style.setProperty('background-image', 'none', 'important');
    el.style.setProperty('border-color', CTA, 'important');
    el.style.setProperty('color', CTA_INK, 'important');
    el.querySelectorAll('*').forEach(function (k) { k.style.setProperty('color', CTA_INK, 'important'); });
  }

  function brandHeaderText(el) {
    /* Titulos que Releasit escribe en negro puro (rgba(0,0,0,1)) via config del panel */
    var c = parseRGB(getComputedStyle(el).color);
    if (c && c[0] < 40 && c[1] < 40 && c[2] < 40) {
      el.style.setProperty('color', NAVY, 'important');
    }
  }

  function paint() {
    /* 1) Botones de compra/confirmación de Releasit: si no están en amarillo, se corrigen */
    document.querySelectorAll(BTN_SEL).forEach(function (el) {
      if (isPrepay(el)) return;
      if (getComputedStyle(el).backgroundColor !== CTA_RGB) brandButton(el);
    });

    /* 1b) Badges de ofertas: SIEMPRE amarillo de marca, tenga el color que tenga (panel incluido) */
    document.querySelectorAll(PLAQUE_SEL).forEach(function (el) {
      if (getComputedStyle(el).backgroundColor !== CTA_RGB) brandButton(el);
    });

    /* 1c) Titulos en negro puro del panel (cabecera del modal, "Método de envío") → navy */
    document.querySelectorAll(HEADER_TITLE_SEL + ', ' + SHIPPING_TITLE_SEL).forEach(brandHeaderText);

    /* 2) Cazador dentro de los contenedores de Releasit (modal, ofertas, popup "¡Espera!") */
    document.querySelectorAll(SCOPE_SEL).forEach(function (root) {
      var nodes = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
      nodes.forEach(function (el) {
        if (el.tagName === 'IMG' || el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'svg') return;
        if (isPrepay(el)) return;
        var cs = getComputedStyle(el);
        var bg = parseRGB(cs.backgroundColor);
        var bc = parseRGB(cs.borderTopColor);
        if (isRed(bg)) { brandButton(el); return; }
        if (isPink(bg)) {
          el.style.setProperty('background', WASH, 'important');
          el.style.setProperty('background-color', WASH, 'important');
        }
        if (isRed(bc)) el.style.setProperty('border-color', BLUE, 'important');
      });
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; paint(); }, 60);
  }

  paint();
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.body || document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class']
    });
  }
  document.addEventListener('DOMContentLoaded', schedule);
  setTimeout(paint, 1200);
  setTimeout(paint, 3500);
  /* Red de seguridad: pasada ligera periódica (el modal aparece en cualquier momento). */
  setInterval(paint, 1500);
})();
